import { Dispatch } from 'react';
import {
    getDiscountFromEventListings,
    hasBogoTickets,
    hasEarlyBirdTickets,
} from '../../utils/discounts';
import { EventAction, EventActionType } from '../EventContext';
import { fetchTicketExpressCheckoutInfo } from './api';
import type { TicketDataType } from './types';

export const fetchDataAndUpdateTicketData =
    (
        setIsFetchComplete: (isComplete: boolean) => void,
        setTicketData: (ticketData: TicketDataType) => void,
    ) =>
    async (url: string, dispatch: Dispatch<EventAction>) => {
        setIsFetchComplete(false);
        try {
            const response = await fetchTicketExpressCheckoutInfo(url);
            const expressCheckoutResponse = {
                compactCheckoutDisqualifications:
                    response.data.event.compactCheckoutDisqualifications,
                panelDisplayPrice:
                    response.data.components.conversionBar.panelDisplayPrice,
                ticketClasses:
                    response.data.event_listing_response.tickets.ticketClasses,
                availability:
                    response.data.event_listing_response.tickets.availability,
            };
            setTicketData(expressCheckoutResponse);
            dispatch({
                type: EventActionType.setDiscounts,
                payload: {
                    hasEarlyBirdTicketsValue: hasEarlyBirdTickets(
                        response.data.event_listing_response.tickets,
                    ),
                    discountValue: getDiscountFromEventListings(
                        response.data.env.localeInfo.locale,
                        response.data.event_listing_response.tickets,
                    ),
                    hasBogoTicketsValue: hasBogoTickets(
                        response.data.event_listing_response.tickets,
                    ),
                },
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsFetchComplete(true);
        }
    };

export const normalizeDisqualificationKeys = (
    compactCheckoutDisqualifications: TicketDataType['compactCheckoutDisqualifications'],
) => {
    return {
        discountCode: compactCheckoutDisqualifications.discount_code,
        hasAddons: compactCheckoutDisqualifications.has_addons,
        hasDiscounts: compactCheckoutDisqualifications.has_discounts,
        hasDonations: compactCheckoutDisqualifications.has_donations,
        hasInventoryTiers: compactCheckoutDisqualifications.has_inventory_tiers,
        hasWaitingRoom: compactCheckoutDisqualifications.has_waiting_room,
        hasWaitlist: compactCheckoutDisqualifications.has_waitlist,
        isCanceled: compactCheckoutDisqualifications.is_canceled,
        isPostponed: compactCheckoutDisqualifications.is_postponed,
        isRsvp: compactCheckoutDisqualifications.is_rsvp,
        isSalesEnded: compactCheckoutDisqualifications.is_sales_ended,
        moreThanOneTicket:
            compactCheckoutDisqualifications.more_than_one_ticket,
        reservedSeating: compactCheckoutDisqualifications.reserved_seating,
        soldOut: compactCheckoutDisqualifications.sold_out,
    };
};
